import React from 'react';

/**
 * Shared Peersona sparkle glyph. Path geometry is lifted from
 * ``assets/images/svgs/peersona-grey-26.svg`` (the same mark
 * ``PeerAvatar`` renders) so every Peersona affordance uses one badge.
 * Inline so callers can tint via ``currentColor`` and resize freely.
 */
interface PeersonaSparkleProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const PeersonaSparkle: React.FC<PeersonaSparkleProps> = ({ size = 14, className, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden
    className={className}
    style={style}
  >
    <path d="M16.4958 12.0049C11.8609 13.5362 10.3175 15.0799 8.78614 19.7145C8.66015 20.0955 8.12137 20.0955 7.9954 19.7145C6.46412 15.0796 4.92041 13.5362 0.285768 12.0049C-0.0952561 11.8789 -0.0952561 11.3401 0.285768 11.2142C4.92068 9.68287 6.46407 8.13916 7.9954 3.50452C8.12139 3.12349 8.66017 3.12349 8.78614 3.50452C10.3174 8.13943 11.8611 9.68282 16.4958 11.2142C16.8768 11.3401 16.8768 11.8789 16.4958 12.0049Z" />
    <path d="M19.8576 4.3936C17.5407 5.15874 16.7684 5.93104 16.0022 8.24894C15.9398 8.43945 15.6704 8.43945 15.6069 8.24894C14.8417 5.93204 14.0694 5.15979 11.7515 4.3936C11.561 4.33112 11.561 4.06174 11.7515 3.99823C14.0684 3.23309 14.8407 2.46079 15.6069 0.142886C15.6694 -0.0476287 15.9387 -0.0476287 16.0022 0.142886C16.7674 2.45979 17.5397 3.23204 19.8576 3.99823C20.0481 4.06071 20.0481 4.33009 19.8576 4.3936Z" />
  </svg>
);
